module.exports = __webpack_public_path__ + "img/swipe_card.b17e2c03.png";